export default "__VITE_ASSET__RPei5wo___"